import React from "react";
import { CircularProgress } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import ResourcesCard from "../../../components/Content/ResourcesCard/index";
import ResourcesModal from "../../../components/Modals/ResourcesModal";
import PractitionerDisclaimer from "../../../components/Modals/PractitionerDisclaimer/index";
import {
  ConfirmationSnackbar,
  ErrorSnackbar,
} from "../../../components/Common/CustomSnackbar";
import { FooterText } from "../../../components/Common/FooterText";
import {
  RootBox,
  StyledBackdrop,
  GridContainer,
} from "./Resources.styles";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  FOOTER_TEXT,
  SNACKBAR_MESSAGES,
  RESOURCE_PAGE_DATA,
} from "./Resources.constants";
import { useResources } from "./Resources.hooks";
import iaihLogo from "../../../assets/images/iaih.png";

const Resources = () => {
  const {
    modalState,
    setModalState,
    disclaimerModalState,
    setDisclaimerModalState,
    formData,
    setFormData,
    loading,
    success,
    setSuccess,
    errorState,
    setErrorState,
    dataURItoBlob,
    handleSave,
    handleDisclaimerSave,
    practitioner,
  } = useResources();

  const successMessage = practitioner
    ? SNACKBAR_MESSAGES.EDIT_SUBMITTED
    : SNACKBAR_MESSAGES.SUBMISSION_RECEIVED;

  return (
    <RootBox>
      <StyledBackdrop open={loading}>
        <CircularProgress color="inherit" />
      </StyledBackdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, message: "" })}
        errorMsg={errorState.message}
      />
      <ConfirmationSnackbar
        snackbarState={success}
        handleSnackbarClose={() => setSuccess(false)}
        text={successMessage}
      />
      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        icon={iaihLogo}
        videoUrl={VIDEO_URL}
      />

      <GridContainer container spacing={2} alignItems="stretch">
        {RESOURCE_PAGE_DATA.map((item) => (
          <ResourcesCard
            key={item.id}
            setModalState={setModalState}
            title={item.title}
            link={item.link}
            openModal={item.openModal}
          />
        ))}
      </GridContainer>

      <ResourcesModal
        open={modalState}
        handleClose={() => setModalState(false)}
        formData={formData}
        setFormData={setFormData}
        handleSave={handleSave}
        dataURItoBlob={dataURItoBlob}
        setErrorState={setErrorState}
      />
      <PractitionerDisclaimer
        open={disclaimerModalState}
        handleClose={() => setDisclaimerModalState(false)}
        onSave={handleDisclaimerSave}
      />
      <FooterText>{FOOTER_TEXT}</FooterText>
    </RootBox>
  );
};

export default Resources;
